import React, { useEffect, useState } from 'react';
import GlobalStyles, { IconGradientDefs, StyledToastContainer } from './styles/GlobalStyles.styles';
import Router from './Router';
import { BrowserRouter } from 'react-router-dom';
import { AuthContext, AuthContextProvider } from './Context/authContext';
import 'react-toastify/dist/ReactToastify.min.css';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/zoom.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { SocketContextProvider } from './Context/socketContext';
import { LinkedinScrapperCsvContext } from './Context/linkedinScrapperCsvContext';
import { SubListLeadsContextProvider } from './Context/subListLeadsContext';
import { JobLeadsContextProvider } from './Context/jobLeadsContext';
import { CampaignAnalyticsContextProvider } from './Context/getCampaignName';
import { PendingApprovalsContextProvider } from './Context/pendingApprovalsContext';
import { DownloadRistrictionContextProvider } from './Context/downloadRistriction';
import { StorybookProvider } from './Context/AppProvider';
import Toast from './components/molecules/Toast';
import { CrowSetup } from './components/CrowSetup';
import { useContextHook } from 'use-context-hook';
import { useIntercom } from './hooks/useIntercom';

const App = () => {
  const [stripe, setStripe] = useState(null);
  const [stripeError, setStripeError] = useState(false);


  useEffect(() => {
    if (process.env.REACT_APP_STRIPE_PUSBLISH_KEY) {
      loadStripe(process.env.REACT_APP_STRIPE_PUSBLISH_KEY)
        .then(instance => {
          if (instance) {
            setStripe(instance);
          } else {
            setStripeError(true);
          }
        })
        .catch(err => {
          Toast({ type: 'error', message: err.message || 'Stripe failed to load' });
          setStripeError(true);
        });
    } else {
      setStripeError(true);
    }
  }, []);

  if (stripeError) {
    return (
      <>
        <div>⚠️ Stripe failed to load. Please refresh or contact support.</div>

      </>
    );
  }

  const IntercomBoot = () => {
    useIntercom();
    return null;
  };

  return (
    <Elements stripe={stripe}>
      <BrowserRouter>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
          <AuthContextProvider>
            <StorybookProvider>
              <CampaignAnalyticsContextProvider>
                <PendingApprovalsContextProvider>
                <LinkedinScrapperCsvContext>
                  <SubListLeadsContextProvider>
                    <JobLeadsContextProvider>
                      <DownloadRistrictionContextProvider>
                        <SocketContextProvider>
                          <GlobalStyles />
                          <IconGradientDefs />
                          <IntercomBoot />
                          <Router />
                          <StyledToastContainer />
                          {/* <CrowSetup /> */}
                        </SocketContextProvider>
                      </DownloadRistrictionContextProvider>
                    </JobLeadsContextProvider>
                  </SubListLeadsContextProvider>
                </LinkedinScrapperCsvContext>
                </PendingApprovalsContextProvider>
              </CampaignAnalyticsContextProvider>
            </StorybookProvider>
          </AuthContextProvider>
        </GoogleOAuthProvider>
      </BrowserRouter>
    </Elements>
  );
};

export default App;
